<script setup lang="ts">
  import { MagnifyingGlassIcon as MagnifyingGlassSolidIcon } from '@heroicons/vue/24/solid'
  import {
    CalendarIcon,
    GlobeEuropeAfricaIcon,
    HashtagIcon,
    NewspaperIcon,
    PhotoIcon,
    PlusIcon,
    SparklesIcon,
    TagIcon
  } from '@heroicons/vue/24/outline'
  import type { FunctionalComponent } from 'vue'

  export type OmniboxActionType =
    | 'empty'
    | 'product'
    | 'facet'
    | 'topic'
    | 'skill'
    | 'search'
    | 'ai'
    | 'identifier'
    | 'event'
    | 'map'

  export interface OmniboxAction {
    key: string
    type: OmniboxActionType
    label: string
    sublabel?: string
    action: () => void
  }

  const props = defineProps<{
    items: OmniboxAction[]
    selectedIndex: number
    variant: 'desktop' | 'mobile'
  }>()

  const emit = defineEmits<{
    (e: 'update:selectedIndex', value: number): void
  }>()

  const ICONS: Record<OmniboxActionType, FunctionalComponent> = {
    search: MagnifyingGlassSolidIcon,
    topic: NewspaperIcon,
    product: PhotoIcon,
    facet: TagIcon,
    empty: PlusIcon,
    skill: SparklesIcon,
    ai: SparklesIcon,
    identifier: HashtagIcon,
    event: CalendarIcon,
    map: GlobeEuropeAfricaIcon
  }

  function hover(index: number) {
    emit('update:selectedIndex', index)
  }
</script>

<template>
  <ul class="menu w-full normal-case">
    <li
      v-for="(item, index) in items"
      :key="item.key"
    >
      <a
        :class="index === props.selectedIndex ? 'bg-base-200' : ''"
        @mousedown="
          variant === 'desktop'
            ? ($event.preventDefault(), item.action())
            : null
        "
        @click="variant === 'mobile' ? item.action() : null"
        @mouseenter="hover(index)"
        @touchstart.passive="hover(index)"
      >
        <component
          :is="ICONS[item.type]"
          class="size-5"
        />
        <span class="flex flex-col items-start">
          <span
            :class="
              variant === 'mobile' ? 'text-base font-medium' : 'font-medium'
            "
            >{{ item.label }}</span
          >
          <span
            v-if="item.sublabel"
            :class="
              variant === 'mobile'
                ? 'max-w-xs truncate text-sm opacity-60'
                : 'max-w-60 truncate text-xs opacity-60'
            "
          >
            {{ item.sublabel }}
          </span>
        </span>
      </a>
    </li>
  </ul>
</template>
